import { minMax } from "@tiptap/core";
const getFakeReferenceElement = (editor) => {
  const { view } = editor;
  const { from, to } = view.state.selection;
  return {
    getBoundingClientRect: () => posToDOMRect(view, from, to)
  };
};
const posToDOMRect = (view, from, to) => {
  const editorRect = view.dom.getBoundingClientRect();
  const minPos = 0;
  const maxPos = view.state.doc.content.size;
  const resolvedFrom = minMax(from, minPos, maxPos);
  const resolvedEnd = minMax(to, minPos, maxPos);
  const start = view.coordsAtPos(resolvedFrom);
  const end = view.coordsAtPos(resolvedEnd, -1);
  const top = Math.min(start.top, end.top);
  const bottom = Math.max(start.bottom, end.bottom);
  const left = editorRect.left;
  const right = editorRect.right;
  const width = right - left;
  const height = bottom - top;
  const x = left;
  const y = top;
  const data = {
    top,
    bottom,
    left,
    right,
    width,
    height,
    x,
    y
  };
  return {
    ...data,
    toJSON: () => data
  };
};
export {
  getFakeReferenceElement
};
//# sourceMappingURL=get-fake-reference-element.js.map
